import React, {Component} from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import Styles from './style.css';
import HeaderDashboardOne from "../../components/header-dashboard-one/component";
import UserCampaignsRunning from "../../components/user-campaigns-running/component";
import UserCampaignsRunningEdit from "../../components/user-campaigns-running-edit/component";
import UserCampaignsHistory from "../../components/user-campaigns-history/component";
import UserCampaignsHistoryEdit from "../../components/user-campaigns-history-edit/component";
import UserBillingInvoices from "../../components/user-billing-invoices/component";
import UserProfile from "../../components/user-profile/component";
import UserInvite from "../../components/user-invite/component";
import UserSettings from "../../components/user-settings/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {userRegister} from "../../services/userRegister";
import {langRegister} from "../../services/langRegister";
import {cartRegister} from "../../services/cartRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {imagesRegister} from "../../services/imagesRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import UserInsights from "../../components/user-insights/component";
import {tokenRegister} from "../../services/tokenRegister";
import UserCampaignsArchived from "../../components/user-campaigns-archived/component";

import UserSettlements from "../../components/user-settlements/component";

class User extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            selected: "",
            dropdown: {
                campaigns: false,
                billing: false
            },
            user: {},
            campaigns_active: 0,
            campaigns_history: 0,
            campaigns_archived: 0
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._setView();
        this._updateUser();
        this._resetSignUp();
        this._updateCampaigns();

        //GOOGLE ANALYTICS
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactGA.pageview('/user');
            ReactGA4.send({ hitType: "pageview", page: "/user" });
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }

    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this._setView();
            window.scrollTo(0, 0);
        }
    }

    _updateUser() {
        let user = userRegister.get();
        if(user){
            this.setState({
                user: user,
                reseller: user.reseller,
                inhouse: user.inhouse,
                reseller_type: user.reseller_type
            });
            if(user.socialData){
                this.setState({
                    settlements: user.socialData.settlements? user.socialData.settlements: user.socialData.settlements
                });
            }
        }
    }

    _updateCampaigns(){
        dataRegister.getCampaignsCount(salesChannelRegister.get('market'), langRegister.lang()).then((response) => {

            let AWAITING_PAYMENT = response.AWAITING_PAYMENT?response.AWAITING_PAYMENT:0;
            let SETUP_CBM = response.SETUP_CBM?response.SETUP_CBM:0;
            let RUNNING = response.RUNNING?response.RUNNING:0;
            let AUTO_BILL = response.AUTO_BILL?response.AUTO_BILL:0;
            let READY = response.READY?response.READY:0;
            let ENDED = response.ENDED?response.ENDED:0;
            let ENDED_RENEW = response.ENDED_RENEW?response.ENDED_RENEW:0;
            let TERMINATED = response.TERMINATED?response.TERMINATED:0;
            let TERMINATED_ENDED = response.TERMINATED_ENDED?response.TERMINATED_ENDED:0;
            let TERMINATED_RENEW = response.TERMINATED_RENEW?response.TERMINATED_RENEW:0;
            let ARCHIVED = response.ARCHIVED?response.ARCHIVED:0;
            let DISAPPROVED = response.DISAPPROVED?response.DISAPPROVED:0;
            let ARCHIVED_DISAPPROVED = response.ARCHIVED_DISAPPROVED?response.ARCHIVED_DISAPPROVED:0;
            let RELEASE = response.RELEASE?response.RELEASE:0;

            this.setState({
                campaigns_active: AWAITING_PAYMENT + RUNNING + AUTO_BILL + READY + SETUP_CBM + DISAPPROVED + RELEASE,
                campaigns_history: ENDED + ENDED_RENEW + TERMINATED_ENDED + TERMINATED + TERMINATED_RENEW,
                campaigns_archived: ARCHIVED + ARCHIVED_DISAPPROVED,
                isLoading: false
            });

        }, (error) => {
            if(error.status === 401){
                tokenRegister.remove();
                userRegister.remove();
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login");
            }else{
                this.setState({isLoading: false, error: true});
            }
        });
    }

    _setView(){
        try{
            this.setState({selected: this.props.location.pathname}, () => {
                if(this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +  "/user/billing/payment" || this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +  "/user/billing/receipts"){
                    this.state.dropdown.billing = true;
                    this.setState({dropdown: this.state.dropdown});
                }else if(this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +  "/user/campaigns/running" || this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +  "/user/campaigns/history" || this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +  "/user/campaigns/archived"){
                    this.state.dropdown.campaigns = true;
                    this.setState({dropdown: this.state.dropdown});
                }
            });
        }catch (error) {}
    }

    _resetSignUp() {
        cartRegister.remove();
        quotesRegister.remove();
        imagesRegister.remove();
    }

    _goTo(value){
        this.setState({selected: value}, () => {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + value)
        });
    }

    _renderText(item) {
        return langRegister.get("user", item);
    }

    render() {
        return (
            <div>
                {
                    !this.state.isLoading &&
                    <div>
                        <span className={Styles.mobileMenu}><HeaderDashboardOne props={this.props}/></span>
                        <div className={Styles.container}>
                            <div className={Styles.menu}>
                                <div className={Styles.menuHeader}>
                                    <img onClick={() => {
                                        if(this.props.location.pathname.indexOf("running") === -1){
                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name')  +  "/user/campaigns/running")
                                        }else{
                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name'))
                                        }
                                    }} className={Styles.menuHeaderLogo} src={salesChannelRegister.get('logo_dashboard')}/>
                                </div>
                                <div onClick={() => {
                                    this.state.dropdown.campaigns = !this.state.dropdown.campaigns;
                                    this.setState({dropdown: this.state.dropdown})
                                }} className={Styles.menuItem}>
                                    <img className={Styles.menuItemIcon} src={require("../../assets/images/gloce-icon.svg")}/>
                                    <div className={Styles.menuItemTitle}>
                                        {this._renderText("item_1")}
                                    </div>
                                    <img
                                        className={
                                            cx(Styles.menuItemArrow,
                                                {
                                                    [Styles.menuItemArrowActive]: this.state.dropdown.campaigns,
                                                })
                                        } src={require("../../assets/images/arrow-icon-grey.svg")}/>
                                </div>

                                <div className={
                                    cx(Styles.menuDropdown,
                                        {
                                            [Styles.menuDropdownOpenCampaigns]: this.state.dropdown.campaigns,
                                        })
                                }>


                                    <div onClick={() => this._goTo("/user/campaigns/running")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: this.state.selected.indexOf("running") !== -1,
                                                     [Styles.menuItemPassive]: this.state.dropdown.campaigns,
                                                 })
                                         }>
                                        {
                                            this.state.selected.indexOf("running") !== -1 &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/flag-icon-white.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_3")}
                                        </div>
                                        {
                                            this.state.campaigns_active > 0 &&
                                            <div className={Styles.menuItemIndicator}>
                                                {this.state.campaigns_active}
                                            </div>
                                        }
                                    </div>

                                    <div onClick={() => this._goTo("/user/campaigns/history")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: this.state.selected.indexOf("history") !== -1,
                                                     [Styles.menuItemPassive]: this.state.dropdown.campaigns,
                                                 })
                                         }>
                                        {
                                            this.state.selected.indexOf("history") !== -1 &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/arrow_down_white.png")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_4")}
                                        </div>
                                        {
                                            this.state.campaigns_history > 0 &&
                                            <div className={cx(Styles.menuItemIndicator, Styles.menuItemIndicatorOrange)}>
                                                {this.state.campaigns_history}
                                            </div>
                                        }
                                    </div>

                                    <div onClick={() => this._goTo("/user/campaigns/archived")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: this.state.selected.indexOf("archived") !== -1,
                                                     [Styles.menuItemPassive]: this.state.dropdown.campaigns,
                                                 })
                                         }>
                                        {
                                            this.state.selected.indexOf("archived") !== -1 &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/cloud_icon.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_12")}
                                        </div>
                                        {
                                            this.state.campaigns_archived > 0 &&
                                            <div className={cx(Styles.menuItemIndicator, Styles.menuItemIndicatorGrey)}>
                                                {this.state.campaigns_archived}
                                            </div>
                                        }
                                    </div>

                                </div>

                                <div onClick={() => {
                                    this.state.dropdown.billing = !this.state.dropdown.billing;
                                    this.setState({dropdown: this.state.dropdown})
                                }} className={Styles.menuItem}>
                                    <img className={Styles.menuItemIcon} src={require("../../assets/images/sheets_white_icon.png")}/>
                                    <div className={Styles.menuItemTitle}>
                                        {this._renderText("item_5")}
                                    </div>
                                    <img
                                        className={
                                            cx(Styles.menuItemArrow,
                                                {
                                                    [Styles.menuItemArrowActive]: this.state.dropdown.billing,
                                                })
                                        } src={require("../../assets/images/arrow-icon-grey.svg")}/>
                                </div>

                                <div className={
                                    cx(Styles.menuDropdown,
                                        {
                                            [Styles.menuDropdownOpen]: this.state.dropdown.billing,
                                        })
                                }>
                                    <div onClick={() => this._goTo("/user/billing/receipts")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +  "/user/billing/receipts",
                                                     [Styles.menuItemPassive]: this.state.dropdown.billing,
                                                 })
                                         }>
                                        {
                                            this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +  "/user/billing/receipts" &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/price_white_icon.png")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_6")}
                                        </div>
                                    </div>

                                </div>

                                <div onClick={() => this._goTo("/user/profile")}
                                     className={
                                         cx(Styles.menuItem,
                                             {
                                                 [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +  "/user/profile",
                                             })
                                     }>
                                    {
                                        this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +  "/user/profile" &&
                                        <div className={Styles.menuItemSelectedBorder}/>
                                    }
                                    <img className={Styles.menuItemIcon}
                                         src={require("../../assets/images/user-icon-white.svg")}/>
                                    <div className={Styles.menuItemTitle}>
                                        {this._renderText("item_7")}
                                    </div>
                                </div>

                                <div onClick={() => this._goTo("/user/settings")}
                                     className={
                                         cx(Styles.menuItem,
                                             {
                                                 [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +  "/user/settings",
                                             })
                                     }>
                                    {
                                        this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +  "/user/settings" &&
                                        <div className={Styles.menuItemSelectedBorder}/>
                                    }
                                    <img className={Styles.menuItemIcon}
                                         src={require("../../assets/images/settings-icons-white.svg")}/>
                                    <div className={Styles.menuItemTitle}>
                                        {this._renderText("item_9")}
                                    </div>
                                </div>

                                {
                                    (this.state.reseller || this.state.inhouse) &&
                                    <div onClick={() => this._goTo("/user/insights")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +  "/user/insights",
                                                 })
                                         }>
                                        {
                                            this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +  "/user/insights" &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/stats_icon.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_11")}
                                        </div>
                                    </div>
                                }

                                {
                                    (this.state.reseller || this.state.inhouse) && this.state.settlements &&//this.state.reseller_type === "commission" &&
                                    <div onClick={() => this._goTo("/user/settlements")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +  "/user/settlements",
                                                 })
                                         }>
                                        {
                                            this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +  "/user/settlements" &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/stack-icon-white.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_13")}
                                        </div>
                                    </div>
                                }

                            </div>
                            <div className={Styles.content}>
                                <Route exact path={this.props.match.url + "/campaigns/running"} component={UserCampaignsRunning}/>
                                <Route exact path={this.props.match.url + "/campaigns/running/:hash"} component={UserCampaignsRunningEdit}/>
                                <Route exact path={this.props.match.url + "/campaigns/archived"} component={UserCampaignsArchived}/>
                                <Route exact path={this.props.match.url + "/campaigns/history"} component={UserCampaignsHistory}/>
                                <Route exact path={this.props.match.url + "/campaigns/history/:hash"} component={UserCampaignsHistoryEdit}/>
                                <Route exact path={this.props.match.url + "/billing/receipts"} component={UserBillingInvoices}/>
                                <Route exact path={this.props.match.url + "/profile"} component={UserProfile}/>
                                <Route exact path={this.props.match.url + "/invite"} component={UserInvite}/>
                                <Route exact path={this.props.match.url + "/settings"} component={UserSettings}/>
                                <Route exact path={this.props.match.url + "/insights"} component={UserInsights}/>
                                <Route exact path={this.props.match.url + "/settlements"} component={UserSettlements}/>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
            </div>
        );
    }
}

export default User;


// WEBPACK FOOTER //
// ./src/pages/user/component.js